import { render, staticRenderFns } from "./GradientBackground.vue?vue&type=template&id=6d5eda2f&scoped=true"
import script from "./GradientBackground.vue?vue&type=script&lang=js"
export * from "./GradientBackground.vue?vue&type=script&lang=js"
import style0 from "./GradientBackground.vue?vue&type=style&index=0&id=6d5eda2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5eda2f",
  null
  
)

export default component.exports